import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setShowSearchPopup } from 'redux-thunk/redux/slices/settings.slice'
import CommonPopup from 'components/ui-kit/CommonPopup/index'

const SearchPopup = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <CommonPopup
      modalCloseHandler={() => dispatch(setShowSearchPopup(false))}
    >
      <div className='heading-wrap'>
        <h5 className='modal-title text-white'>{t('search') || 'Search'}</h5>
      </div>
      <p className='text-center m-0'>{t('noGamesFound') || 'No games available'}</p>
    </CommonPopup>
  )
}

export default SearchPopup
